import { createBrowserRouter, Navigate } from "react-router-dom";
import { Pages } from "@/utils/routes.utils.ts";
import Layout from "@/components/Layout.tsx";
import { Signup } from "./screens/Signup/Signup.screen";
import { Signin } from "./screens/Signin/Signin.screen";
import { PinScreen } from "./screens/Pin/Pin.screen";
import { AuthGuard, GuestGuard } from "./guards/Guard";
import Home from "./screens/Home";
import Wallet from "./screens/Wallet/Wallet";
import { ProductDetails } from "./screens/ProductDetails/ProductDetails";
import { SettingsScreen } from "./screens/Settings/SettingsScreen";
import { RewardsScreen } from "./screens/Rewards/Rewards";
import { useBrandConfig } from "./utils/useBrandConfig";
import NotFound from "./screens/404/404";

export const useAppRouter = () => {
    const { name } = useBrandConfig();

    const brandName = name.toLowerCase().replace(/\s+/g, '');

    const routes = [
        {
            element: <GuestGuard />,
            children: [
                {
                    path: Pages.SINGIN,
                    element: <Layout />,
                    errorElement: <Navigate to={Pages.SINGIN} />,
                    children: [
                        { index: true, element: <Signin /> },
                        { path: Pages.PIN, element: <PinScreen /> },
                        { path: Pages.SIGNUP, element: <Signup /> },
                    ],
                },
            ],
        },
        {
            element: <AuthGuard />,
            children: [
                {
                    path: Pages.HOME,
                    element: <Home />,
                    errorElement: <Navigate to={Pages.HOME} />,
                    children: [
                        { index: true, element: <Wallet /> },
                        { path: Pages.PRODUCT_DETAILS, element: <ProductDetails /> },
                    ],
                },
                ...(brandName !== 'adamlippes'
                    ? [{ path: Pages.REWARDS, element: <RewardsScreen />, errorElement: <Navigate to={Pages.REWARDS} /> }]
                    : []),
                { path: Pages.SETTINGS, element: <SettingsScreen />, errorElement: <Navigate to={Pages.SETTINGS} /> },
                { path: "*", element: <NotFound /> },
            ],
        },
    ];

    return createBrowserRouter(routes);
};
